import locales from '../consts/locales';

export const formatEventDate = (date: number) => {
  const newDate = new Date(date);
  const day = newDate.getDate();
  const month = newDate.toLocaleString(locales.GB, { month: 'long' });
  const year = newDate.getFullYear();
  return `${day} ${month} ${year}`;
};

export const parseEventDate = (date: string) =>
  parseInt(date.replace(/\/Date\(|\)\//, ''), 10);

export const hasEventDateExpired = (
  date: number | null,
  gracePeriod = 900000, // 15 minutes grace period
) => Boolean(date && Date.now() + gracePeriod >= date);

export default (date: string) => formatEventDate(parseEventDate(date));
